import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Inputs } from 'src/lib/constants';
import { AllInputs } from 'src/types/inputs';

type ValueOf<T> = T[keyof T];

export type InputValue = ValueOf<AllInputs> | null;

export type InputsReducer = Partial<AllInputs>;

type UpdateInputPayloadGeneric<T> = {
  [K in keyof T]: {
    name: K;
    value: T[K] | undefined;
  };
}[keyof T];

export type UpdateInputPayload = UpdateInputPayloadGeneric<AllInputs>;

export type UpdateInputsPayload = {
  inputs: InputsReducer;
};

const initialState: InputsReducer = {};
const inputsReducer = createSlice({
  name: 'inputs',
  initialState,
  reducers: {
    initializeInputs(state, action: PayloadAction<InputsReducer>) {
      return { ...state, ...action.payload };
    },
    updateInput(state, action: PayloadAction<UpdateInputPayload>) {
      const { name, value } = action.payload;
      if (Inputs[name]) {
        // @ts-expect-error
        state[name] = value;
      }
    },
  },
});

export const { updateInput, initializeInputs } = inputsReducer.actions;
export default inputsReducer.reducer;
